import { Fragment, FunctionComponent } from "react";
import {
  StyledBreadcrumb,
  StyledSeperator,
  StyledStage,
} from "./breadcrumb.styles";
import { faChevronRight } from "./icon-library";

export type BreadcrumbStageType = "past" | "current" | "future";

export interface BreadcrumbStage {
  type: BreadcrumbStageType;
  text: string;
}

interface BreadcrumbProps {
  stages: BreadcrumbStage[];
}

const Breadcrumb: FunctionComponent<BreadcrumbProps> = ({ stages }) => {
  return (
    <StyledBreadcrumb>
      {stages.map((stage, index) => {
        return (
          <Fragment key={index}>
            <StyledStage $stage={stage.type}>{stage.text}</StyledStage>
            {index < stages.length - 1 && (
              <StyledSeperator icon={faChevronRight} />
            )}
          </Fragment>
        );
      })}
    </StyledBreadcrumb>
  );
};

export default Breadcrumb;
